module.exports = __webpack_public_path__ + "img/ice_pellets_light.54609c36.svg";